import { Link } from '@tanstack/react-router'
import { Gift } from 'lucide-react'
import { Button } from '@/components/ui/Controls'
import { Vortex } from '@/components/animations/Vortex'
import { DEFAULT_FREE_CREDITS } from '@/features/billing/plans'

export function HomeHero() {
  return (
    <section className="relative overflow-hidden flex flex-col justify-start min-h-screen pt-[10vh] sm:pt-[20vh] pb-20">
      {/* Vortex background — positioned absolutely behind the hero content */}
      <Vortex
        className="pointer-events-auto"
        particleColor="#43C995"
        discColor="#43C995"
        discCount={60}
        particleCount={3000}
        speed={0.04}
        particleSize={0.5}
        discLineWidth={1.0}
        radius={115}
        opacity={0.55}
        enableCursorInteraction={true}
        cursorInfluence={0.1}
      />
      
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 sm:px-12 lg:px-16 flex flex-col items-start text-left">
        <div className="mb-4 inline-flex items-center rounded-full border border-line bg-surface/20 backdrop-blur-md px-3 py-1 text-[11px] font-medium uppercase tracking-wide text-ink-muted">
          GitHub DevOps assistant
        </div>
        
        <h1 className="max-w-3xl text-3xl sm:text-4xl md:text-6xl font-semibold leading-tight text-ink tracking-tight">
          Ask your repositories anything. <br className="hidden xl:block" /> Review PRs in seconds.
        </h1>
        
        <p className="mt-6 max-w-xl text-base text-ink-muted sm:text-lg md:text-xl leading-relaxed">
          An AI assistant with real access to your GitHub — through an MCP server that logs
          every call, asks before it changes anything, and bills only for what it actually uses.
        </p>

        <div className="mt-8 flex flex-row flex-wrap items-center justify-start gap-3">
          <Link to="/signin">
            <Button variant="primary" className="px-6 py-2.5 text-sm h-11 shadow-pop hover:shadow-primary/20 transition-all">
              Start building for free
            </Button>
          </Link>
          <Link to="/pricing">
            <Button className="px-6 py-2.5 text-sm h-11 bg-surface/50 backdrop-blur-md hover:bg-raised transition-colors">
              View pricing
            </Button>
          </Link>
        </div>

        <p className="mt-6 flex items-center justify-start gap-2 text-[13px] text-ink-muted bg-surface/20 backdrop-blur-md px-4 py-1.5 rounded-full border border-line">
          <Gift aria-hidden="true" className="h-3.5 w-3.5 text-ok" />
          <span>
            <span className="font-medium text-ink">
              {DEFAULT_FREE_CREDITS} free credits
            </span>{' '}
            on sign-up. No card required.
          </span>
        </p>
      </div>
    </section>
  )
}
